import React, { useState } from 'react';
import { Mail, ShieldCheck } from 'lucide-react';
import API from '../utils/api';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import OtpInput from './OtpInput';
import BrandLogo from './BrandLogo';

export default function OtpVerification({ email, title = 'Verify Email', subtitle, onVerified, onBack }) {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [error, setError] = useState('');
  const { completeAuth } = useAuth();

  const verify = async (e) => {
    e.preventDefault();
    setError('');
    if (otp.trim().length !== 6) return setError('Enter the 6 digit OTP');
    setLoading(true);
    try {
      const res = await API.post('/auth/verify-otp', { email, otp });
      completeAuth(res.data);
      toast.success('Email verified successfully');
      if (onVerified) onVerified(res.data);
    } catch (err) {
      setError(err.response?.data?.message || 'OTP verification failed');
    } finally {
      setLoading(false);
    }
  };

  const resend = async () => {
    setResending(true);
    setError('');
    try {
      await API.post('/auth/resend-otp', { email });
      toast.success('OTP sent again');
    } catch (err) {
      setError(err.response?.data?.message || 'Unable to resend OTP');
    } finally {
      setResending(false);
    }
  };

  return (
    <div>
      <div className="auth-header" style={{ textAlign: 'center', marginBottom: 18 }}>
        <BrandLogo size={52} radius={14} fallbackIcon={ShieldCheck} />
        <h1 style={{ fontSize: 21, fontWeight: 700, marginBottom: 4 }}>{title}</h1>
        <p style={{ color: 'var(--gray)', fontSize: 13, lineHeight: 1.5 }}>
          {subtitle || 'Enter the OTP sent to your email.'}
        </p>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--orange-soft)', color: 'var(--orange)', padding: '10px 12px', borderRadius: 10, fontSize: 12, fontWeight: 700, marginBottom: 14 }}>
        <Mail size={14} /> {email}
      </div>

      {error && (
        <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', color: 'var(--red)', padding: '9px 12px', borderRadius: 8, fontSize: 13, marginBottom: 12 }}>
          {error}
        </div>
      )}

      <form onSubmit={verify}>
        <OtpInput value={otp} onChange={setOtp} disabled={loading} />
        <button type="submit" className="btn-primary" disabled={loading} style={{ width: '100%', justifyContent: 'center', padding: '12px' }}>
          {loading ? 'Verifying...' : 'Verify & Continue'}
        </button>
      </form>

      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, marginTop: 12 }}>
        <button type="button" onClick={resend} disabled={resending} style={{ background: 'none', color: 'var(--orange)', fontWeight: 700, fontSize: 13 }}>
          {resending ? 'Sending...' : 'Resend OTP'}
        </button>
        {onBack && (
          <button type="button" onClick={onBack} style={{ background: 'none', color: 'var(--gray)', fontWeight: 700, fontSize: 13 }}>
            Back
          </button>
        )}
      </div>
    </div>
  );
}
